<template>
  <Card>
    <CardContent class="flex justify-between items-center gap-2">
      <div class="flex flex-col gap-1">
        <CardTitle class="flex gap-2 items-start">
          {{ workflow.name }}
          <Badge v-if="hasActions" :variant="statusProperties.badgeVariant">{{ statusProperties.content }}</Badge>
          <Badge v-else variant="red">Missing Actions</Badge>
        </CardTitle>
        <CardDescription class="flex flex-col gap-4">
          {{ workflow.description }}
          <Badge variant="outline">{{ getDefinition(workflow.trigger_definition_key).trigger.name }}</Badge>
        </CardDescription>
      </div>
      <div class="flex gap-2 items-center">
        <router-link :to="{ name: 'WorkflowDetail', params: { id: workflow.id } }">
          <TButton color="white">Edit</TButton>
        </router-link>
        <Switch :model-value="isActive()" @update:model-value="handleToggle" />
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import type { WorkflowStatus } from '@/api/entity_types/workflow/Workflow';
import { Card, CardDescription, CardContent, CardTitle } from '@/components/ui/card';
import { useWorkflowDefinitionsStore } from '@/stores/workflow/workflowDefinitions';
import { Switch } from '@/components/ui/switch';
import { Badge } from '@/components/ui/badge';
import { useWorkflowStatus } from '../useWorkflowStatus';
import type { ListWorkflowsResponse } from '@/api/workflows';
import { computed } from 'vue';

type WorkflowListItemProps = {
  workflow: ListWorkflowsResponse;
};

const hasActions = computed(() => workflow.actions_size > 0);

const { workflow } = defineProps<WorkflowListItemProps>();

const workflowDefinitionStore = useWorkflowDefinitionsStore();
const { toggleStatus, isActive, statusProperties } = useWorkflowStatus(workflow);
const { getDefinition } = workflowDefinitionStore;

const handleToggle = async () => {
  const newStatus = await toggleStatus();
  if (newStatus) emit('status-changed', workflow.id, newStatus);
};

type Emits = {
  'status-changed': [workflowId: number, val: WorkflowStatus];
};

const emit = defineEmits<Emits>();
</script>
